import { Component } from '@angular/core';

@Component({
  selector: 'app-offer-page',
  templateUrl: './offer-page.component.html',
  styleUrls: ['./offer-page.component.css'],
  host: {
    class: 'app-page'
  }
})
export class OfferPageComponent {

}
